(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('experience-discovery')) {
    customElements.define(
      'experience-discovery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.tabs = Array.from(this.querySelectorAll('[data-discovery-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-discovery-panel]'));

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(tab));
            tab.addEventListener('keydown', (event) => {
              let nextIndex = index;
              if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') nextIndex = 0;
              if (event.key === 'End') nextIndex = this.tabs.length - 1;
              if (nextIndex === index) return;
              event.preventDefault();
              this.tabs[nextIndex].focus();
              this.activate(this.tabs[nextIndex]);
            });
          });
        }

        activate(activeTab) {
          const update = () => {
            const activeId = activeTab.dataset.discoveryTab;
            this.tabs.forEach((tab) => {
              const selected = tab === activeTab;
              tab.classList.toggle('is-active', selected);
              tab.setAttribute('aria-selected', selected ? 'true' : 'false');
              tab.tabIndex = selected ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.discoveryPanel !== activeId;
            });
          };

          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
